<template>
    <div class="blog-posts">
        <div class="container px-0">
            <template v-if="post">
                <blog-post :value="post" :preview="false"></blog-post>
            </template>
            <template v-else-if="posts">
                <blog-post v-for="post in posts" :key="post.id" :value="post" :preview="true"></blog-post>
            </template>
        </div>
    </div>
</template>

<script>
    import Network from "../helpers/Network.js";
    import SeoHelper from "../helpers/SeoHelper.js";
    import BlogPost from "./blog-post.vue";

    export default {
        name: `blog-posts`,
        components: {BlogPost},
        metaInfo() {
            if (this.post) {
                return SeoHelper.getMeta(this.post.title, this.post.description, this.post.keywords, this.post.author, this.post.cover_image);
            } else {
                return SeoHelper.getMeta(this.tr(`The latest news|Les dernières nouvelles`));
            }
        },
        props: {
            source: { type: String, required: true },
            lang: { type: String, default: `all` },
            limit: { type: Number, default: 100 }
        },
        computed: {
            section() {
                switch (this.$route.params.section) {
                    case `post`:
                        return `post`;
                    default:
                        return this.$route.params.section;
                }
            },
            id() {
                return this.source && this.$route.params.id;
            }
        },
        data() {
            return {
                posts: null,
                post: null,
                loading: true
            }
        },
        mounted() {
            this.update();
        },
        methods: {
            update() {
                this.post = null;
                this.posts = null;
                if (this.section === `post` && this.id) {
                    Network.get(`/blog/post/${this.id}`)
                        .then(resp => {
                            this.post = resp.data;
                            this.$forceUpdate();
                            this.$meta().refresh();
                        });
                } else {
                    Network.get(`/blog/posts/${this.source}/${this.lang}/${this.limit}`)
                        .then(resp => {
                            this.posts = resp.data;
                            this.$forceUpdate();
                            this.$meta().refresh();
                        });
                }
            }
        },
        watch: {
            $route(to) {
                if (to.name === `blog`) {
                    this.update();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .blog-posts {
        .container {
            max-width: 740px;
            padding: 0 20px;

            > .media.blog-post {
                width: 100%;

                ::v-deep .media-body {
                    width: 100%;
                }
            }

        }
    }
</style>
